import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../components/ui/table';
import { BarChart3 } from 'lucide-react';

const PlanBreakdownPanel = ({ planBreakdown, totalServableCustomers }) => {
  if (!planBreakdown || planBreakdown.length === 0) return null;

  return (
    <Card className="border border-gray-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <BarChart3 className="h-5 w-5 text-orange-500" />
          Meal Counts by Plan
          <span className="ml-auto text-sm font-normal text-gray-500">{totalServableCustomers} total customers</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Plan</TableHead>
              <TableHead>Plan Term</TableHead>
              <TableHead className="text-right">Customers</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {planBreakdown.map((group, idx) => (
              <TableRow key={idx}>
                <TableCell className="font-medium">{group.plan}</TableCell>
                <TableCell className="text-gray-600">{group.planTerm}</TableCell>
                <TableCell className="text-right">
                  <span className="inline-flex items-center justify-center min-w-[2rem] px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 font-bold text-sm">
                    {group.customerCount}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PlanBreakdownPanel;
